<script setup lang="ts">
import { computed } from "vue";

type BarColor = "red" | "purple" | "blue" | "yellow";

type Props = {
  active?: boolean;
  color?: BarColor;
};

const props = withDefaults(defineProps<Props>(), {
  active: false,
  color: "red",
});

const barColorClass = computed(() => {
  switch (props.color) {
    case "purple":
      return "bg-kekkle-purple";
    case "blue":
      return "bg-kekkle-blue";
    case "yellow":
      return "bg-kekkle-yellow";
    case "red":
    default:
      return "bg-kekkle-red";
  }
});

const trackColorClass = computed(() => {
  switch (props.color) {
    case "purple":
      return "bg-kekkle-purple/20";
    case "blue":
      return "bg-kekkle-blue/20";
    case "yellow":
      return "bg-kekkle-yellow/20";
    case "red":
    default:
      return "bg-kekkle-red/20";
  }
});
</script>

<template>
  <div
    class="relative h-0.5 w-full shrink-0 overflow-hidden bg-transparent"
    role="progressbar"
    aria-hidden="true"
  >
    <transition
      enter-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      leave-active-class="transition-opacity duration-300"
      leave-to-class="opacity-0"
    >
      <div v-if="active" class="absolute inset-0" :class="trackColorClass">
        <div
          data-testid="kekkle-progress-runner"
          class="kekkle-progress-runner absolute inset-y-0 w-1/3 rounded-full"
          :class="barColorClass"
        />
      </div>
    </transition>
  </div>
</template>

<style scoped>
.kekkle-progress-runner {
  animation: kekkle-indeterminate 1.2s ease-in-out infinite;
}

@keyframes kekkle-indeterminate {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(350%);
  }
}
</style>
